import { render, staticRenderFns } from "./RegisterHeaderSteps.vue?vue&type=template&id=4e6e2f3d&scoped=true&"
import script from "./RegisterHeaderSteps.vue?vue&type=script&lang=ts&"
export * from "./RegisterHeaderSteps.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterHeaderSteps.vue?vue&type=style&index=0&id=4e6e2f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6e2f3d",
  null
  
)

export default component.exports